const websiteMaintenance = [
  {
      path: '/websiteMaintenance',
      name: 'websiteMaintenance',
      component: () => import(/* webpackChunkName: "websiteMaintenance" */ '@/views/websiteMaintenance/websiteMaintenance'),
      meta: {
        name: '专利交易中心-全网维护中',
        breadCrumbName: '专利交易中心',
        isNoNav: true
      }
  },
];

export default websiteMaintenance
